const { REACT_APP_API_BASE_ENDPOINT } = process.env;

export const SKILL_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/skill`;
export const JOB_SKILL_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/job_skill`;
export const LEARNING_JOURNEY_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/learning_journey`;
export const LEARNING_JOURNEY_COURSE_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/learning_journey_course`;
export const JOB_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/job`;
export const COURSE_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/course`;
export const SKILL_COURSE_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/skill_course`;
export const REGISTRATION_ENDPOINT = `${REACT_APP_API_BASE_ENDPOINT}/api/v1/registration`;
